<div class="grey-25-bg pr-xsmall-t">
  <div [ngClass]="{ 'flex flex--row flex--space-around flex--middle column-gap': isMobile$ | async }">
    <fin-flight-selection-sort-by
      [showBestFlightsTab]="false"
      [showPoints]="true"
      [resultsAmount]="(boundsList$ | async)?.length"
      [selectedSortBy$]="selectedSortBy$"
      [isMobile$]="isMobile$"
      [fastestFlightPrice]="(fastestPrice$ | async)?.toString()"
      [lowestPrice]="(lowestPrice$ | async)?.toString()"
      [ngClass]="{ 'flex-1': (isMobile$ | async) }"
      (sortByChange)="onSelectSortBy($event)"
    />
    <fin-flight-selection-filters
      [showFlightSelectionFilters]="showFlightSelectionFilters"
      [isTravelClassChoicesDisabled]="(boundsStatus$ | async) === AirOffersStatus.PENDING"
      [travelClasses$]="availableCabinClasses$"
      [resultsAmount]="(boundsList$ | async)?.length"
      [showRefundability]="false"
      [filters$]="filters$"
      [selectionPhase]="selectionPhase"
      [layoverAmounts]="layoverAmounts$ | async"
      [originLocationCode]="originLocationCode$ | async"
      [destinationLocationCode]="destinationLocationCode$ | async"
      [cabinLastRequestParam$]="lastRequestParam$"
      [isTravelClassDisabled]="isTravelClassDisabled$ | async"
      (setFilter)="onSetFilter($event)"
      (resetFilter)="onResetFilter($event)"
      (resetAllFilters)="onResetAllFilters()"
      (showSpinner)="showSpinner.emit()"
      [ngClass]="{ 'flex-1': (isMobile$ | async) }"
    />
  </div>

  <div class="flex flex--column min-height-for-filters">
    <ng-container *ngIf="(boundsStatus$ | async) === AirOffersStatus.PENDING || isLoading; else boundResults">
      <fin-loader
        class="font-body-1 flex flex--center empty-and-loading-state"
        [type]="LoaderType.EMBEDDED"
        [title]="'flightSorting.loaderText'"
      ></fin-loader>
    </ng-container>

    <ng-template #boundResults>
      <ul class="unstyled" [class.transition-appear--animate]="boundsList$ | finDelay | async">
        <li
          *ngFor="let boundObs of boundsList$ | finObsToArray; let i = index"
          class="flight-item mr-xsmall-b transition-appear"
        >
          <ng-container *ngIf="boundObs | async as bound">
            <input
              class="is-vishidden"
              type="radio"
              [attr.name]="boundType + '-selectedBound'"
              [checked]="bound.selected"
              [formControl]="control"
              [value]="bound"
              [attr.id]="'input-' + bound.boundId"
              (focusin)="bound.selected = true"
              (focusout)="bound.selected = false"
            />
            <label [attr.for]="'input-' + bound.boundId" [attr.aria-labelledby]="'aria-' + bound.boundId"></label>
            <div
              class="bound-selection block rounded-large border overflow-hidden white-bg"
              [class.nordic-blue-900-border]="bound.selected"
              [class.shadow-highlight]="bound.selected"
              [attr.data-testid]="'bound-selection-selected-' + bound.selected"
            >
              <div class="pr-xsmall-t pr-small-x">
                <fcom-ufo
                  [arrival]="{
                    dateTime:
                      (bound.arrival.dateTime | finTime) +
                      ' ' +
                      (bound.arrival.dateTime | finDateFormat: 'WEEKDAY_SHORT'),
                    city: bound.arrival.cityName,
                    airportCode: bound.arrival.locationCode,
                    airport: bound.arrival.name,
                  }"
                  [departure]="{
                    dateTime:
                      (bound.departure.dateTime | finTime) +
                      ' ' +
                      (bound.departure.dateTime | finDateFormat: 'WEEKDAY_SHORT'),
                    city: bound.departure.cityName,
                    airportCode: bound.departure.locationCode,
                    airport: bound.departure.name,
                  }"
                  [tails]="tails$ | finMap: bound.boundId | async | finTailNames"
                  [isByBusOnly]="isBusOnlyConnections$ | finMap: bound.boundId | async"
                  [airlines]="bound.uniqueAirlineNames"
                  [duration]="bound.duration | finDuration | async"
                  [stops]="bound.stops"
                  [showViewDetails]="true"
                  (viewDetails)="showDetails.emit(bound)"
                  [flightNumbers]="bound.itinerary | finFlightNumbers"
                ></fcom-ufo>
              </div>
              <fcom-notification
                *ngIf="bound.hasBusLeg"
                class="mr-xsmall-t pr-small-x bound-selection-notes"
                [theme]="NotificationTheme.SUSTAINABILITY"
                [iconName]="SvgLibraryIcon.SUSTAINABILITY"
                [linkUrl]="'routeNotification.sustainabilityLink.url' | finLocalization"
                [linkText]="'routeNotification.sustainabilityLinkText' | finLocalization"
                [linkOpenInNewWindow]="true"
                [compact]="true"
                data-testid="bus-notification"
              >
                <span *ngIf="bound.priorityServicesAvailable">
                  {{ 'routeNotification.sustainableRoute' | finLocalization }}
                </span>
                <span *ngIf="!bound.priorityServicesAvailable">
                  {{ 'routeNotification.sustainableRouteNoPriorities' | finLocalization }}
                </span>
              </fcom-notification>
              <ng-container *ngIf="selectedOutbound$ | async as selected">
                <fcom-notification
                  *ngIf="
                    selected.operatingAirlineCodes.length === 1 &&
                    selected.operatingAirlineCodes.includes('AY') &&
                    boundType === BoundType.inbound &&
                    !(bound.operatingAirlineCodes.length === 1 && bound.operatingAirlineCodes.includes('AY'))
                  "
                  class="mr-xsmall-t pr-small-x bound-selection-notes"
                  [theme]="NotificationTheme.WARNING"
                  [compact]="true"
                >
                  <span> {{ 'award.notifications.partnerFlightsPrices' | finLocalization }} </span>
                </fcom-notification>
              </ng-container>

              <fcom-notification
                *ngIf="bound.notes?.length > 0"
                class="mr-xsmall-t pr-small-x bound-selection-notes"
                [theme]="NotificationTheme.WARNING"
                [compact]="true"
              >
                <span *ngFor="let note of bound.notes; let last = last"
                  >{{ 'ticketSelection.notes.' + note | finLocalization }}<span *ngIf="!last">, </span></span
                >
              </fcom-notification>
              <div class="pr-xsmall-t">
                <fin-fare-family-list
                  data-testid="fare-family-list"
                  [id]="'fare-family-' + bound.boundId"
                  [fareFamilies$]="bound.fareFamilies | finToObservable"
                  [currencyCode]="currencyCode$ | async"
                  [showUpsellCard]="true"
                  [showKoreaNotification]="false"
                  [isShowTotalPrice]="false"
                  [isShortHaul$]="isShortHaul$"
                  [isAwardFlow]="true"
                  (selectFareFamily)="selectBoundAndFareFamily(bound, $event?.fareFamily?.fareFamilyCode)"
                  (cabinIsExpanded)="handleCabinExpanding(bound, $event)"
                  [preSelectedFareFamilyId]="preSelectedFareFamilyId$ | async"
                  [enableFareFamilyAutoScroll$]="enableFareFamilyAutoScroll$"
                  (fareFamilyAutoScrolled)="cabinAutoScrolled()"
                >
                </fin-fare-family-list>
              </div>
            </div>
            <span class="is-vishidden" [attr.id]="'aria-' + bound.boundId">{{
              'ticketSelection.aria.boundInformation'
                | finLocalization
                  : {
                      departureLocationCode: bound.departure.locationCode,
                      departureDate: bound.departure.dateTime | finDateFormat: 'FULL_NO_YEAR',
                      departureTime: bound.departure.dateTime | finTime,
                      arrivalLocationCode: bound.arrival.locationCode,
                      arrivalTime: bound.arrival.dateTime | finTime,
                      arrivalDate: bound.arrival.dateTime | finDateFormat: 'FULL_NO_YEAR',
                      stops: bound.stops,
                      priceStartingFrom: boundObs | finMap: 'cheapestPrice' | finOffersPrice: currencyCode$ | async,
                      operatingAirlineNames: bound.uniqueAirlineNames | finJoin: ', ',
                    }
            }}</span>
          </ng-container>
        </li>
      </ul>

      <ng-container *ngIf="(boundsList$ | async)?.length === 0">
        <fin-flight-filters-empty-state (clearAllFilters)="clearAllFilters()"></fin-flight-filters-empty-state>
      </ng-container>
    </ng-template>
  </div>
</div>
